import React, { createContext, useState, useEffect } from "react";
import * as func from "../../api/apiHelper";
import * as urls from "../../api/urlHelper";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [matchseekerMasterData, setMatchSeekerMasterData] = useState({});
  const [reloadContext, setReloadContext] = useState(false);

  const getNecessaryData = async () => {
    const matchSeekersMasterDataApiResponse = await func.get(
      urls.GET_MST_MATCHSEEKER_URL
    );

    if (matchSeekersMasterDataApiResponse.status === 200) {
      const finalResponse = {
        ...matchSeekersMasterDataApiResponse.data,
        "mst-gender": [
          { gender: "Male", _id: "Male" },
          { gender: "Female", _id: "Female" },
        ],
      };
      setMatchSeekerMasterData(finalResponse);
    }
  };

  useEffect(() => {
    const isTokenPresent = func.getAccessToken();

    if (isTokenPresent) {
      getNecessaryData();
    }
  }, [reloadContext]);

  return (
    <AppContext.Provider
      value={{
        matchseekerMasterData,
        setReloadContext,
        reloadContext,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
